import react from "react";
const SCOPES = [
    'openid',
    'email',
    'profile',
    'groups',
    'offline_access'
];
const CLI_SCOPES = [
    'openid',
    'email',
    'profile',
    'groups'
];
const NONCE_COOKIE_NAME = 'chrono-auth-nonce';
const AuthenticationContext = /*#__PURE__*/ react.createContext({
    isLoading: false,
    config: void 0,
    oktaClient: void 0,
    oktaImpersonateClient: void 0,
    oktaCliClient: void 0,
    oktaCliImpersonateClient: void 0,
    currentUser: void 0,
    refreshCurrentUser: void 0,
    refreshAuthToken: ()=>Promise.resolve(),
    loginRoute: ''
});
export { AuthenticationContext, CLI_SCOPES, NONCE_COOKIE_NAME, SCOPES };

//# sourceMappingURL=AuthenticationContext.js.map